// Service locator. Game.js populates this during boot; every other module reads
// from it instead of importing siblings directly. Keeps the dependency graph flat
// so modules can be developed and tested in isolation.
export const S = {
  renderer: null,   // THREE.WebGLRenderer
  scene: null,      // THREE.Scene (world)
  camera: null,     // THREE.PerspectiveCamera (world cam)
  viewScene: null,  // THREE.Scene (viewmodel, rendered with separate FOV)
  viewCamera: null, // THREE.PerspectiveCamera (viewmodel cam)
  engine: null,     // Engine instance (render/Engine.js)
  postfx: null,     // PostFX instance
  input: null,      // Input instance
  time: null,       // Time instance
  audio: null,      // Audio instance
  world: null,      // Arena instance
  player: null,     // Player instance
  spawner: null,    // Spawner instance
  progression: null,
  inventory: null,  // Inventory instance (unequipped operator tokens)
  loot: null,
  forge: null,      // Forge screen (formula + inventory, hard-paused)
  formula: null,    // Formula instance (the player's live expression)
  hud: null,
  vfx: null,        // { particles, decals, tracers }
  state: null,      // GameState
};

export default S;
